import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Markdown, Card } from '../elements';

const LatestNews = (props) => {
  const { heading, idx } = props;

  // getting 3 articles data form graphql
  const { allSanityArticles } = useStaticQuery(graphql`
    {
      allSanityArticles(limit: 3, sort: { fields: date, order: DESC }) {
        nodes {
          id
          title
          articleSubtitle
          slug {
            current
          }
          date
          featuredImage {
            alt
            asset {
              _id
              gatsbyImageData(width: 392, height: 260)
            }
          }
          categories {
            title
          }
        }
      }
    }
  `);

  return (
    <div className="section">
      <div className="container">
        {heading && (
          <div className="columns is-centered mb-5">
            <div className="column is-8 has-text-centered">
              <Markdown idx={idx} className="pb-2 has-text-grey-dark">
                {heading}
              </Markdown>
            </div>
          </div>
        )}

        <div className="columns is-multiline">
          {allSanityArticles.nodes.map((article) => (
            <Card
              image={article.featuredImage.asset.gatsbyImageData}
              alt={article.featuredImage.asset.alt || 'Capextax'}
              title={article.title}
              key={article.id}
              date={article.date}
              subtitle={article.articleSubtitle}
              slug={`/news/${
                article.slug.current === 'homepage' ? '/' : article.slug.current
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
